export default "__VITE_ASSET__726798d9__"